import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { FichasRegistroBienesCulturales } from 'app/models/fichaRegistro.model';
import { Tarea } from 'app/models/tareas.model';
import { FormTypeWidgetComponent } from 'app/modules/GlobalComponents/id-formulario-widget.component';
import { StatusStickerComponent } from 'app/modules/GlobalComponents/status sticker.component';
import { UserAvatarWidgetComponent } from 'app/modules/GlobalComponents/user-avatar-component';
import { BienesCulturalesService } from '../bienes-culturales.service';

@Component({
    selector: 'lista-bienes',
    templateUrl: 'lista-bienes.component.html',
    imports:[
        CommonModule, 
        MatIconModule,
        MatTableModule,
        MatPaginatorModule,
        
        //component
        UserAvatarWidgetComponent,
        StatusStickerComponent
                
    ]
})

export class ListaBienesComponent implements OnInit {
    @Input() dataSource:FichasRegistroBienesCulturales;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    
    // paginator variables
    public totalResultItems = 0;
    public pageSize= 10;
    public isLoadingResults = true; 

    gestionesTableColumns: string[] = [
        'imagen',
        'no-registro',
        'nombre',
        'propietario',
        'seccion',
        'categoria',
        'registrado-por',
        'fecha-modificacion',
    ];
    constructor(
        private router: Router,
        private bienesCulturalesService:BienesCulturalesService
    ) { 
       
    }

    ngOnInit() { 
         this.totalResultItems= this.dataSource.total
    }

    ngAfterViewInit() {

        if (this.paginator) {
            this.paginator.page.subscribe(() => {
            const pageIndex = this.paginator.pageIndex;
            const start = pageIndex * this.pageSize;
            const end = start + this.pageSize;

            // Obtener los filtros
            const currentFilters = this.bienesCulturalesService.bienesCulturealesFilterParmasValue;

            // Validar si existen filtros 
            if (currentFilters) {
                // agregar paginación a los filtros
                const newParams = {
                ...currentFilters,
                inicio: start,
                max: end
                };

                this.bienesCulturalesService.getFichaRegistro(newParams);
            } else {
                // Si no hay filtros, hacer la llamada solo con paginación
                const newParams = {
                inicio: start,
                max: end
                };

                this.bienesCulturalesService.getFichaRegistro(newParams);
            }
            });
        }
    }


    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource'] && this.dataSource) {
            this.totalResultItems = this.dataSource.total;
            this.isLoadingResults = false;
        }
    }

    openTaskDetails(bienCulturalUuid: string) {
        this.router.navigate(['bienes-culturales/detalle/', bienCulturalUuid]);
    }
}